// extracted by mini-css-extract-plugin
export var infoItem = "_u7-2";
export var title = "_u7-0";
export var value = "_u7-1";